<template>
  <div ref="container" class="container">
    <div v-if="dataReady" class="questionnaireList">
      <div class="top-banner">
        <img class="top-banner__image" src="../../assets/images/patrolman_banner@2x.png">
      </div>
      <div class="questionnaireHeader">
        <div class="title">活动说明</div>
        <div class="summary patrolman" v-html="question.summary" ref="summary">
        </div>
      </div>
      <div class="questionnaireBody">
        <div class="question-list" v-for="item in question.questionList" :key="item.questionid">
<!--           <div class="question-title">Q{{index + 1}}：{{item.questionname}}</div> -->
          <van-checkbox-group v-if="!isRadio" v-model="answer[item.id]" @change="onCheckboxChange">
            <van-cell-group>
              <van-cell v-for="(option,optionIndex) in item.optionlist" :key="option.id" @click="toggle(optionIndex, option.id, option.content)">
                <template #title>
                  <div class="radio_content">
                    <div class="left-side">
                      <div v-if="option.logo" class="logo" :style="{backgroundImage: 'url(' + option.logo + ')'}"></div>
                      <p class="votes">{{option.num}}票</p>
                    </div>
                    <div class="label">
                      <div class="label_val" v-html="option.content"></div>
                      <span class="more" @click.stop="seemore(option.content)">...「查看详情」</span>
                    </div>
                  </div>
                </template>
                <template v-if="!expired && !notstart" #right-icon>
                  <van-checkbox :disabled="hasSelected && !selectedIds.includes(option.id)" shape="square" :name="option.id" ref="checkboxes" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
          <van-radio-group v-else v-model="answer[item.id]">
            <van-cell-group>
              <van-cell v-for="option in item.optionlist" :key="option.id" @click="choose(item.id, option.id)">
                <template #title>
                  <div class="radio_content">
                    <!-- <img v-if="option.logo" class="logo" :src="option.logo" alt=""> -->
                    <div class="left-side">
                      <div v-if="option.logo" class="logo" :style="{backgroundImage: 'url(' + option.logo + ')'}"></div>
                      <p class="votes">{{option.num}}票</p>
                    </div>
                    <div class="label">
                      <div class="label_val" v-html="option.content"></div>
                      <span class="more" @click.stop="seemore(option.content)">...「查看详情」</span>
                    </div>
                  </div>
                </template>
                <template v-if="!expired && !notstart" #right-icon>
                  <van-radio class="green" :name="option.id" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
      <div class="fixed-footer" :class="{show: showFooter}">
        <div class="option-button" @click="checkVote">查看排行榜</div>
        <div class="option-button" :class="{disabled: expired || notstart}" @click="submit">{{expired ? '投票已截止' : notstart ? '投票未开始' : '确定投票'}}</div>
      </div>
      <!-- <div class="questionnaireFooter" v-if="question.questionList && question.questionList.length > 0">
        <van-button v-if="question.mode === '投票'" class="btn rankinglistBtn" @click="goRanking">查看排行榜</van-button>
        <van-button :class="question.isresult ? 'btn isresult' : 'btn'" color="#DB2D2D" :disabled="question.isresult" @click="submit">{{btnText}}</van-button>
      </div> -->
      <van-popup v-model="show">
        <div class="popup-close"><van-icon name="cross" @click="closePopup" /></div>
        <div class="questionnaire_popup">
          <!-- <div class="questionnaire_popup_header">
            <van-icon name="cross" @click="closePopup" />
          </div> -->
          <div class="questionnaire_popup_body" v-html="nowShow"></div>
        </div>
      </van-popup>
      <van-dialog v-model="showQrcode" title="投票成功" @closed="$router.replace({path: 'patrolmanRanking'})">
        <p class="qrcode-title">扫码登录广东自然保护地开放预约平台<br>预约参观自然保护地、体验科普课程。</p>
        <img class="qrcode-image" src="../../assets/images/qrcode_nature.jpg" />
      </van-dialog>
    </div>
    <div class="loading" v-if="!dataReady">
      <van-loading type="spinner" color="#1989fa" size="50px" />
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  import $ from 'jquery'
  export default {
    name: 'patrolman',
    data () {
      return {
        id: 11,
        dataReady: false,
        show: false,
        nowShow: '',
        question: {},
        rankingList: [],
        isRadio: false,
        notstart: false,
        expired: false,
        hasSelected: false,
        selectedIds: [],
        showFooter: false,
        showQrcode: false,
        answer: {},
        btnText: "确认提交"
      }
    },
    created () {
      this.$toast.allowMultiple()
      // this.dataReady = true
      this.$fetch.get(API.QUESTIONNAIREQUESTIONLIST, {
        questionnaireid: this.id
      }).then(res => {
        // console.log(res)
        if (res.data.votetype === '单选') this.isRadio = true
        this.question = res.data
        if (res.data.isresult) {
          this.btnText = '投票'
        } else if (res.data.mode === '投票') {
          this.btnText = '投票'
        } else {
          this.btnText = '确认提交'
        }
        for (var i = 0; i < res.data.questionList.length; i++) {
          // this.answer[] = ''
          if (this.isRadio) {
            this.$set(this.answer,res.data.questionList[i].id,'')
          } else {
            this.$set(this.answer,res.data.questionList[i].id,[])
          }
        }
        if (new Date(res.data.starttime.replace(/-/g,'/')).getTime() > new Date().getTime()) {
          this.notstart = true
        } else if (new Date(res.data.endtime.replace(/-/g,'/')).getTime() < new Date().getTime()) {
          this.expired = true
        }
        if (this.notstart) {
          this.$dialog.alert({
            title: '投票未开始，请留意活动开始时间'
          }).then(() => {
            // on close
          });
        } else if (this.expired) {
          this.$dialog.alert({
            title: '投票已截止'
          }).then(() => {
            // on close
          });
        }

        this.dataReady = true
        this.$nextTick(function () {
          $(".label").each(function(index, el) {
            if ($(el).height() > 100) {
              $(el).height(100)
              $(el).find('.more').show()
            }
          })
          $('.label_val').each(function(index, el) {
            $(el).find('p:first-child').css({'color':'#006840', 'font-weight': 'bold'})
          })
          if (u.indexOf('MicroMessenger') > -1) {
            var summary = this.$refs.summary ? this.$refs.summary.innerText.trim().replace(/\ +/g,"").replace(/[\r\n]/g,"").replace(/\s/g,"").substr(0, 50) : '广东科技报'
            this.$fetch.get(API.GETWECHATINVOKESIGN, {
              url: window.location.href
            }).then(response => {
              let data = response.data
              wx.config({
                debug: false,
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              })
              wx.ready(function(){
                wx.updateAppMessageShareData({
                  title: '守森林、护大海，这些平凡英雄值得您的一票', //res.data.title,
                  desc: '动动手指，为他们加油吧！',// summary,
                  link: window.location.origin + '/#/questionnaire/patrolman',
                  imgUrl: 'https://ms.gdkjb.com/resources/images/logo/wechat_share_linyelogo.jpg',
                  success: function() {
                    console.log('分享成功')
                  }
                })
                wx.updateTimelineShareData({
                  title: '守森林、护大海，这些平凡英雄值得您的一票', //res.data.title,
                  link: window.location.origin + '/#/questionnaire/patrolman',
                  imgUrl: 'https://ms.gdkjb.com/resources/images/logo/wechat_share_linyelogo.jpg',
                  success: function() {
                    console.log('分享成功')
                  }
                })
                wx.onMenuShareWeibo({
                  title: '守森林、护大海，这些平凡英雄值得您的一票', //res.data.title,
                  desc: '动动手指，为他们加油吧！',// summary,
                  link: window.location.origin + '/#/questionnaire/patrolman',
                  imgUrl: 'https://ms.gdkjb.com/resources/images/logo/wechat_share_linyelogo.jpg',
                  success: function() {
                    console.log('分享成功')
                  },
                  cancel: function(){
                    console.log('分享取消')
                  }
                })
              })
            })
          }
        })
      }).catch(error => {
        console.log(error)
      })
    },
    mounted() {
        // 监听滚动事件
      this.$refs.container.onscroll = () => {
        this.handleScroll()
      }
    },
    methods: {
      handleScroll () {
        let scrollTop = this.$refs.container.scrollTop
        this.showFooter = scrollTop >= 400
      },
      getRankingList() {
        this.$fetch.get(API.QUESTIONNAIRERESULTLIST, {
          questionnaireid: this.id
        }).then(res => {
          this.rankingList = res.data.wjStatisticsBeanList
        })
      },
      submit () {
        if (this.notstart) {
          this.$toast.fail('投票未开始，请留意活动开始时间')
          return
        } else if (this.expired) {
          this.$toast.fail('投票已截止')
          return
        }
        var cansubmit = true
        var _this = this
        var answerArr = []
        Object.keys(_this.answer).forEach(function (index) {
          if (_this.answer[index].length < 1) {
            cansubmit = false
          } else {
            if (!_this.isRadio && _this.question.votenum < _this.answer[index].length) {
              _this.$toast(`至多选择${_this.question.votenum}人进行投票`)
              return
            }
            var obj = {
              'wjquestionid': index,
              'optionid': _this.isRadio ? _this.answer[index] : _this.answer[index].join(',')
            }
            answerArr.push(obj)
          }
        })
        console.log(answerArr)
        if (!cansubmit) {
          var cantmsg = this.question.mode === '投票' ? '请选择要投票的人员' : '请先完成所有答题再提交'
          this.$toast(cantmsg)
          return
        }
        if (this.$store.state.token) {
          const load = this.$toast({
            type: 'loading',
            duration: 0,
            loadingType: 'spinner',
            forbidClick: true
          })
          // console.log(answerArr)
          this.$fetch.post(API.SAVEWJRESULT, {
            questionnaireid: this.id,
            questionnairejson: JSON.stringify(answerArr)
          }).then(response => {
            // console.log(response)
            load.clear()
            if (response.status === 405) {
              this.$dialog.alert({
                message: response.message
              })
              // this.showQrcode = true
              return
            }
            if (response.status !== 200) {
              this.$dialog.alert({
                message: response.message
              })
              return
            }
            if (response.data.surplusnum > 0) {
              this.$dialog.alert({
                title: '投票成功',
                message: `还剩余${response.data.surplusnum}次投票机会，欢迎继续投票`
              }).then(() => {
                // Object.keys(this.answer).forEach((key) => {
                //   this.answer[key] = this.isRadio ? '' : []
                // })
                this.$router.replace({
                  path: 'patrolmanRanking'
                })
              })
            } else {
              this.showQrcode = true
              // this.$dialog.alert({
              //   title: '投票成功',
              //   message: '今日投票次数已用完,请明天再来!'
              // }).then(() => {
              //   this.$router.replace({
              //     path: 'patrolmanRanking'
              //   })
              // })
            }
            this.$fetch.get(API.QUESTIONNAIREQUESTIONLIST, {
              questionnaireid: this.id
            }).then(res => {
              this.question = res.data
            })
            // this.$toast.success({
            //   message: this.question.mode === '投票' ? '投票成功！' : '提交成功!',
            //   forbidClick: true
            // })

            // if (this.question.mode === '投票') {
            //   setTimeout(function(){
            //     Object.keys(this.answer).forEach(function (key) {
            //       this.answer[key] = this.isRadio ? '' : []
            //     })
            //     this.$router.replace({
            //       path: 'patrolmanRanking'
            //     })
            //   }, 2000)
            // } else {
            //   setTimeout(function(){
            //     this.$router.replace({
            //       path: '/result',
            //       query: {
            //         type: 'questionnaire'
            //       }
            //     })
            //   }, 2000)
            // }
          }).catch(error => {
            load.clear()
            console.log(error)
          })
        } else {
          let questdata = {
            questionnaireid: this.id,
            questionnairejson: JSON.stringify(answerArr)
          }
          this.$store.commit('savequest', questdata)
          if (u.indexOf('MicroMessenger') > -1) {
            var URL = this.question.mode === '投票' ? '/#/questionnaire/patrolmanRanking?auto=submitquest&mode=patrolman' : '/#/result?type=questionnaire&auto=submitquest'
            var hrefF = process.env.VUE_APP_CURRENTMODE === 'test' ? '/h5' : ''
            this.$fetch.post(API.GETWECHATAUTHURI, {
              url: window.location.origin + hrefF + URL
            })
              .then(response => {
                // console.log(response)
                if (response.status === 200) {
                  window.location.href = response.data.uri
                } else {
                  // console.log(response.message)
                }
              })
          } else {
            this.$dialog.alert({
              message: '请先前往登录再进行投票'
            }).then(() => {
              this.$router.push({
                path: '/login',
                query: {
                  type: 'patrolman',
                  mode: this.question.mode
                }
              })
            })
          }
        }
      },
      toggle(index, id, val) {
        if (this.expired || this.notstart) {
          this.nowShow = val
          this.show = true
          return
        } 
        if (this.hasSelected && !this.selectedIds.includes(id)) {
          this.$toast(`至多选择${this.question.votenum}人进行投票`)
          return
        } 
        this.$refs.checkboxes[index].toggle()
      },
      checkVote() {
        this.$router.replace({
          path: 'patrolmanRanking'
        })
      },
      toVote() {
        this.$router.replace({
          path: 'patrolman',
          query: {
            id: this.id
          }
        })
      },
      seemore (val) {
        this.nowShow = val
        this.show = true
        this.$nextTick(() => {
          $('.questionnaire_popup_body').find('p:first-child').css({'color':'#006840', 'font-weight': 'bold', 'font-size': '16px', 'margin-bottom': '5px'})
        })
        return false
      },
      closePopup () {
        this.show = false
      },
      choose (item, option) {
        if (this.expired || this.notstart) return
        this.$set(this.answer, item, option)
      },
      goRanking () {
        this.$router.replace({
          path: '/questionnaire/ranking',
          query: {
            id: this.id
          }
        })
      },
      onCheckboxChange (names) {
        this.selectedIds = names
        this.hasSelected = names.length === this.question.votenum
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '../../assets/stylus/mixin'
  .questionnaireList
    background #effcd1 url('../../assets/images/patrolman_bg@2x.jpg') no-repeat
    background-size 100%
    background-position-y 210px
    padding-bottom 56px
  .top-banner__image
    display block
    width 100%
  .questionnaireHeader
    margin-top -55px
    border-bottom none
    .title
      color #006740
      text-align center
    .summary
      font-size 15px
      color #006740
  .questionnaireBody
    .question-list
      border-bottom none
      .question-title
        color #006740
      .van-cell-group, .van-cell
        overflow auto
        background transparent url('../../assets/images/flower@2x.png') left bottom
        background-repeat repeat-x
      .van-checkbox-group .van-cell-group .van-cell:active
        background-color rgba(180, 206, 152, 0.3)
      .van-radio-group .van-cell-group .van-cell:active
        background-color rgba(180, 206, 152, 0.3)
      .van-cell::after
        display none
      .van-cell > .votes
        font-size 15px
        color #DB2D2D 
        margin-left 15px
        display flex
        align-items center
      .radio_content .label .more
        background-image linear-gradient(to right, rgba(255,255,255,0.0), #f1fcd4 18px) !important
      .left-side
        position relative
        > .votes
          position absolute
          width 90px
          left 0
          bottom -29px
          text-align center
          color #db2d2d
  .van-radio-group .van-radio[aria-checked=true] .van-radio__icon--checked .van-icon
    background-color transparent
    color #006840
  .fixed-footer
    position fixed
    left 0
    bottom 0
    width 100%
    display flex
    opacity 0
    visibility hidden
    transition 0.3s all ease
    &.show
      opacity 1
      visibility visible
    .option-button
      flex 1
      display flex
      justify-content center
      align-items center
      font-size 15px
      color #fff
      height 56px
      &:first-child
        background-color #2CA8F5
      &:last-child
        background-color #006840
      &:active
        filter brightness(0.9)
      &.disabled
        background-color #a2a2a2
  .questionnaireBody .question-list .van-checkbox-group .van-cell-group .van-cell .van-cell__title .radio_content .label
    margin-bottom 9px 
  .van-popup
      border-radius 8px
  .questionnaire_popup
    width 50vh
    max-height 80vh
    overflow-y scroll
  .popup-close 
    height 40px
    width 100%
    padding 0 15px
    text-align right
    -webkit-box-sizing border-box
    box-sizing border-box
    border-1px()
    .van-icon-cross
      color #666
      font-size 22px
      line-height 40px
  .radio_content .logo
    border 3px solid #a9e0f5
    border-radius 5px
    box-sizing border-box
  .questionnaireBody .question-list .van-checkbox-group .van-cell-group .van-cell
    padding 18px 15px 62px
  .qrcode-title
    margin 22px 15px 15px
    text-align center
  .qrcode-image
    margin-bottom 20px
</style>